"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyFromElem = void 0;
var antd_1 = require("antd");
function copyFromElem(elemId) {
  var _a, _b;
  var text = (_a = document.getElementById(elemId)) === null || _a === void 0 ? void 0 : _a.innerText;
  if (text && typeof navigator !== 'undefined') {
    (_b = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _b === void 0 ? void 0 : _b.writeText(text);
    antd_1.message.success('已複製!');
  }
}
exports.copyFromElem = copyFromElem;